var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect } from 'react';
import RevealList from './RevealList';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import ScrollTo from 'gsap/ScrollToPlugin';
import useViewport from '../../hooks/useViewport';
import './main.scss';
gsap.registerPlugin(ScrollTrigger, ScrollTo);
var ScrollLockHorizontalReveal = function (_a) {
    var data = _a.data;
    var image = data.image;
    var contentRef = useRef(null);
    var wrapperRef = useRef(null);
    var imageRef = useRef(null);
    var _b = useViewport(), visualViewport = _b.visualViewport, breakPoints = _b.breakPoints;
    var isMobile = visualViewport.width <= breakPoints.tablet.width;
    useEffect(function () {
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.scroll-lock-horizontal-reveal_container',
                start: 'top center',
            },
        });
        tl.fromTo([
            '.scroll-lock-horizontal-reveal_heading, .scroll-lock-horizontal-reveal_paragraph',
            '.reveal-list-item',
            '.reveal-list-item-footnote',
        ], {
            opacity: 0,
        }, {
            stagger: {
                amount: 1,
            },
            delay: 0.5,
            duration: 1,
            opacity: 1,
        });
    }, []);
    return (_jsxs("div", __assign({ className: "scroll-lock-horizontal-reveal_container" }, { children: [data.eyebrowTitle && (_jsx("h3", __assign({ className: "scroll-lock-horizontal-reveal_heading" }, { children: data.eyebrowTitle }), void 0)),
            _jsxs("div", __assign({ className: "scroll-lock-horizontal-reveal" }, { children: [_jsx("div", __assign({ className: "scroll-lock-horizontal-reveal_info" }, { children: _jsx("h2", __assign({ className: "scroll-lock-horizontal-reveal_paragraph" }, { children: data.paragraph }), void 0) }), void 0),
                    _jsx("div", __assign({ className: "scroll-lock-horizontal-reveal_points" }, { children: _jsx(RevealList, { listItems: data.revealList, footerNote: data.footerNote }, void 0) }), void 0)] }), void 0)] }), void 0));
};
export default ScrollLockHorizontalReveal;
